<template>
  <div class="jrm-m-c--unit-wrp size-50">
    <div
      class="jrm-m-c--unit"
      :class="{ selected: paymentMethod.handle === paymentCredentialsMethod }"
    >
      <div class="jrm-m-c--unit-name">
        {{ paymentMethod.name }}
      </div>

      <div class="jrm-m-c--unit-desc">
        {{ paymentMethod.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySubscriptionStepPaymentMethod',
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    paymentCredentialsMethod: {
      type: String,
      required: true
    }
  }
}
</script>
